import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, Bug } from "lucide-react";
import { useAdminFeedback } from "@/hooks/useAdminFeedback";
import { useAuth } from "@/hooks/useAuth";
import { UserType } from "@/types/user";
import { getNativeSidePanelButtonClass } from "@/lib/native/nativeSidePanelPosition";

export const AdminFeedbackSidePanel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { hasUnread } = useAdminFeedback(user?.type === UserType.Admin);

  const isDashboard = location.pathname === "/dashboard";
  if (!isDashboard || user?.type !== UserType.Admin) {
    return null;
  }

  return (
    <motion.button
      initial={{ opacity: 0, x: 12 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.25 }}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => navigate("/admin/feedback")}
      className={getNativeSidePanelButtonClass(
        "native-side-panel-btn native-side-panel-btn-admin rounded-l-full pl-1.5 pr-1 py-1 shadow-md hover:shadow-lg transition-shadow group backdrop-blur-sm border border-amber-200/80 bg-gradient-to-r from-amber-50 via-amber-100/90 to-amber-50 dark:from-amber-900/50 dark:to-amber-800/70"
      )}
      aria-label="Feedback och felrapporter"
    >
      <div className="relative inline-flex items-center gap-px md:gap-0.5">
        <Star
          className="w-3 h-3 md:w-3.5 md:h-3.5 shrink-0 fill-amber-400 text-amber-500 group-hover:fill-amber-500 transition-colors drop-shadow-sm"
          strokeWidth={1.5}
        />
        <Bug
          className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0 text-rose-400 group-hover:text-rose-500 transition-colors drop-shadow-sm"
          fill="currentColor"
          strokeWidth={0}
        />
        {hasUnread && (
          <span
            className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-red-500 ring-2 ring-amber-50 shadow-sm"
            aria-hidden
          />
        )}
      </div>
      <div className="absolute inset-0 rounded-l-full bg-amber-200/40 blur-xl -z-10 opacity-0 transition-opacity duration-200 pointer-events-none" />
    </motion.button>
  );
};
